package org.vreo.devicehub.di

import org.koin.core.module.Module


import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.engine.js.Js
import org.koin.dsl.module
import org.vreo.devicehub.features.liveAccess.domain.JsWebRtcController
import org.vreo.devicehub.features.liveAccess.domain.WebRtcController

actual val platformHttpModule: Module
    get() = module {
        single<HttpClientEngine> { Js.create() }
    }

actual fun getPlatformWebRtcController(): WebRtcController {
    return JsWebRtcController()
}